import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { FormikHelpers } from 'formik';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import {
  useGetDigitalDistributionSectionTemplate,
  usePutDigitalDistributionTemplate,
} from 'services/templates/digital-distribution-template';
import { IContractTemplateForm, TEMPLATE_TYPE } from 'services/templates/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { contractTemplateUtil } from 'utils';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const EditDigitalDistributionSectionTemplate = () => {
  const id = useParamId('/templates-extended');

  const { t } = useTranslation();
  const navigate = useNavigate();

  const digitalDistribution = useGetDigitalDistributionSectionTemplate(id);

  const updateDigitalDelivery = usePutDigitalDistributionTemplate(id);

  const goBackToDigitalDistribution = () =>
    navigate(`/templates-extended/digital-distribution/${id}/form`);

  const onUpdateDigitalDistributionSection = async (
    values: IContractTemplateForm,
    formikHelpers: FormikHelpers<IContractTemplateForm>
  ) => {
    const distribution = middleware.template.digitalDistribution.formToQuery(values);

    if (distribution) {

      await updateDigitalDelivery.mutateAsync(distribution, {
        onSuccess: goBackToDigitalDistribution,
        onError: error => onErrorShowAllErrorsToast(error),
      });
    }
  };

  return (
    <Form.Contract
      tittle={`${t('button.edit')} ${
        digitalDistribution.data?.title ??
        t('contract-template.digitalDistribution.title')
      }`}
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToDigitalDistribution}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t(`button.save`)} />
        </Button>
      }
      initialStatus={contractTemplateUtil.distribution.initialStatus}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: digitalDistribution.data
          ? middleware.template.digitalDistribution.queryToForm(
              digitalDistribution.data,
              '1',
              true,
              true
            )
          : contractTemplateUtil.distribution.initialValues(TEMPLATE_TYPE.digitalDistribution),
      }}
      onSubmit={onUpdateDigitalDistributionSection}
      status={{ isLoading: digitalDistribution.isLoading }}
    />
  );
};

export default EditDigitalDistributionSectionTemplate;
